export enum EntityView {
    LIST = 'list',
    CREATE = 'new',
    EDIT = 'edit',
    VIEW = 'view'
}
